import React, { useEffect, useState } from 'react';
import { Box, Typography, Paper, Link } from '@mui/material';
import { globalGetService } from '../../../../utils/globalApiServices';
import { getBillableAssembliesApi } from '../apiServices';
import { useParams } from 'react-router-dom';
import appConfig from '../../../../config';
import { trackActivity } from '../../../../utils/mixpanel';
import { PageLoader } from '../../../../shared_elements';

const BillableAssemblies = () => {
    const { leaseSlug } = useParams();
    const params = { leaseSlug: leaseSlug };
    const [isLoading, setLoading] = useState(false);
    const [billableAssemblies, setBillableAssemblies] = useState([]);
    const domain = appConfig.domain.subDomian;
    const assetTypeMap = {
        1: "aircraft",
        2: "engine",
        3: "apu",
        4: "lg",
        5: "propeller",
        6: "fan",
        7: "hpc",
        8: "hpt",
        9: "lpt",
        10: "component"
    };
    useEffect(() => {
        getBillableAssembilesList();
    }, [])
    const getBillableAssembilesList = (loaderType) => {
        setLoading(true);
        globalGetService(getBillableAssembliesApi(params.leaseSlug)).then(response => {
            setLoading(false);
            setBillableAssemblies(response?.data?.data);
        })
    }
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Headlines`, page_type: page_type, })
    }
    return (
        <Paper className='card-container' sx={{ boxShadow: "0px 0px 0px 1px #BBBBBB", margin: '1px' }}>
            <Box p={1} sx={{ backgroundColor: '#F8F8F8' }}>
                <Typography fontWeight={500} fontSize={16}>Billable Assemblies</Typography>
            </Box>
            <Box className='headlines-box-style' >
                {billableAssemblies?.length > 0 ? billableAssemblies.map((item, index) => (
                    <Box key={index} paddingLeft="5px">
                        <Typography variant="p" sx={{fontSize: '14px'}}>
                            <Link
                                sx={{ cursor: 'pointer' }}
                                onClick={() => { window.open(`${domain}technical-specification/${assetTypeMap[item?.asset_type]=== "landing_gear" ? "lg" :assetTypeMap[item?.asset_type] }/${item?.asset_slug}/basic-details`, '_blank'); handleItemClicked('Billable Assembly Technical Specification Link') }}
                            >{item.name}
                            </Link>
                        </Typography>
                    </Box>
                )) : <Typography sx={{ textAlign: "center", fontSize: 14, fontWeight: 500 }}>No Billable Assemblies</Typography>
                }
            </Box>
            {isLoading ? <PageLoader /> : null}
        </Paper>
    );
};
export default BillableAssemblies;